import React, { useState, useEffect } from 'react';
import { remove } from 'lodash/fp';
import { routes } from 'constants/config';
import { Spinner } from 'ui';
import request from 'utils/request_ajax';
import PreviousAttempt from './PreviousAttempt';
import PreviousAttemptWithResponses from '../../shared/PreviousAttemptWithResponses';

const PreviousAttemptsTab = ({
  scenarioId,
  highlightFirstAttempt,
  hasZiggeoForAllMedia,
}) => {
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [data, setData] = useState({
    attempts: [],
    ziggeoApiKey: null,
    hippoPreviewBase: null,
  });

  useEffect(() => {
    request
      .get(routes.ON_DEMAND_PRACTICE.LEARNING.ATTEMPTS.INDEX(scenarioId))
      .then(fetchedData => {
        setLoading(false);
        setData(fetchedData);
      })
      .fail(() => {
        setLoading(false);
        setLoadError(true);
      });
  }, [scenarioId]);

  const removeAttempt = attemptId => {
    const currentData = { ...data };
    currentData.attempts = remove(
      attempt => attempt.id === attemptId,
      data.attempts,
    );
    setData(currentData);
  };

  const renderPreviousAttempt = (attempt, index) => {
    const {
      ziggeoApiKey,
      hippoPreviewBase,
      hippoThumbnailBase,
      canRequestFeedback,
    } = data;

    if (attempt.scenarioType === 'conversation') {
      return (
        <PreviousAttemptWithResponses
          key={attempt.id}
          attempt={attempt}
          scenarioId={scenarioId}
        />
      );
    }

    return (
      <PreviousAttempt
        highlighted={highlightFirstAttempt && index === 0}
        key={attempt.id}
        apiKey={ziggeoApiKey}
        attempt={attempt}
        removeAttempt={removeAttempt}
        scenarioId={scenarioId}
        hippoPreviewBase={hippoPreviewBase}
        hippoThumbnailBase={hippoThumbnailBase}
        canRequestFeedback={canRequestFeedback}
        hasZiggeoForAllMedia={hasZiggeoForAllMedia}
      />
    );
  };

  return (
    <div>
      {loadError && (
        <div className="fz-24 w-half m-a ta-c">
          {t('practice.on_demand_practice.error.attempts_load')}
        </div>
      )}
      {loading && <Spinner />}
      {!loading && data.attempts.map(renderPreviousAttempt)}
    </div>
  );
};

export default PreviousAttemptsTab;
